"use client";
import {useEffect, useState} from "react";
import {Icon} from "@iconify/react";
import {getShopConfig} from "@/server/shop/get-shop-config";
import PaymentIcons from "../../payment/PaymentIcons";
import Link from "next/link";

export default function Footer({footerData}){
    const shop = getShopConfig();
    const { dark } = shop.theme.header;
    let contentColor;
    let bgColor = 'bg-secondary';
    if(dark) {
        {
            contentColor = 'text-white'
            if(shop.id === 'theno1plug'){
                contentColor = 'text-primary';
            }
        }
    } else {
        contentColor = 'text-white';
        bgColor = 'bg-secondary';
        if(shop.id === 'theno1plug'){
            contentColor = 'text-primary';
        }
    }
    const [openMenu, setOpenMenu] = useState(null);
    const [fdata,setFdata] = useState({});
    const [loading,setLoading] = useState(false);
    const mshopname = shop?.publicSiteName || "Shop Name";
    const footer = footerData?.footer || {};
    const fmenus = footer?.fsections?.menus?.filter(menu => menu && menu.menu_name) || [];
    const acomp = footer?.fsections?.custom;
    const business = footer?.fsections?.custom?.ptext;
    const company = footer?.company;
    const whatsapp = company?.whatsapp || null;
    return (
        <footer className={`py-3 ${contentColor} ${bgColor} border-t-primary border-t-4 print:hidden`}>
            <div className="max-w-7xl mx-auto px-2 py-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    <div>
                        <div className={'font-heading text-xl lg:text-2xl underline underline-offset-6 decoration-2 decoration-primary'}>{acomp?.label || 'Contact us'}</div>
                        <ul className={'list-none mt-3'}>
                            <li>{business?.business_name}</li>
                            <li className={'text-balnce'}>{business?.address_line1}, {business?.address_line2}</li>
                            <li className={'text-balance'}>{business?.region}, {business?.postcode}, {business?.country}</li>
                            {business?.reg_no && (
                                <li>Company No : {business?.reg_no}</li>
                            )}
                            <li className={'mb-1 flex items-center gap-2'}><Icon icon={'mdi:email'}/> <span>{business?.email}</span></li>
                            <li className={'mb-2 flex items-center gap-2'}><Icon icon={'mdi:cellphone'}/> <span>(+44) {business?.phone} </span></li>
                            {/*<li className={'mb-2 flex items-center gap-2'}><Icon icon={'mdi:whatsapp'}/> <span>(+44) {business?.whatsapp}</span></li>*/}
                        </ul>
                    </div>
                    {fmenus?.length > 0 &&
                        fmenus.filter(Boolean).map((fmen, index) => {
                            const isOpen = openMenu === index;
                            return (
                                <div key={index} className="mb-4">
                                    {/* Title */}
                                    <div className="font-heading py-2 lg:py-0 text-xl border-b-2 border-b-primary lg:border-transparent lg:text-2xl lg:underline lg:underline-offset-6 lg:decoration-2 lg:decoration-primary flex justify-between items-center cursor-pointer lg:cursor-default"
                                         onClick={() => setOpenMenu(isOpen ? null : index)}>
                                        {fmen?.menu_name}
                                        <span className="lg:hidden">
                                            <Icon icon={isOpen ? "mdi:chevron-up" : "mdi:chevron-down"} />
                                        </span>
                                    </div>
                                    <ul className={`list-none mt-3 transition-all duration-300 ${isOpen ? "block" : "hidden"} lg:block`}>
                                        {fmen?.mitems?.length > 0 &&
                                            fmen.mitems.map((flink, ldx) => {
                                                let href = "/";
                                                if (flink.type === "pages" && flink.url === "/") {
                                                    href = "/";
                                                } else if (flink.type === flink.url.replace("/", "")) {
                                                    href = `/${flink.type}`;
                                                } else {
                                                    href = `/${flink.type}/${flink.url.replace(/^\//, "")}`;
                                                }
                                                return (
                                                    <li key={ldx} className="mb-2">
                                                        <Link href={href} className="no-underline hover:underline">
                                                            {flink.label}
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            );
                        })}
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-2">
                <div className="flex flex-col lg:flex-row justify-between gap-2">
                    <div className={'text-center lg:text-start'}>
                        <div>You have to be over 18 to purchase from this website.</div>
                        <div className={'text-sm'}>© 2026 {mshopname}</div>
                    </div>
                    <div>
                        <PaymentIcons/>
                    </div>
                </div>
            </div>
            {whatsapp && (
                <div className={'whatsapp fixed bottom-5 left-5 transition-all duration-900'}>
                    <a className={'text-green-600'}
                       rel="noopener noreferrer"
                       aria-label="Chat with us on WhatsApp"
                       href={`https://api.whatsapp.com/send/?phone=44${whatsapp}&text=Hi%2C+need+more+information+about+%2A${mshopname}%2A.+Please+contact+me`}
                       target="_blank"
                    >
                        <Icon className={'text-4xl lg:text-5xl'} icon={'logos:whatsapp-icon'}/>
                        <span className={'hidden'}>Whatsapp</span>
                    </a>
                </div>
            )}
        </footer>
    )
}